export default "__VITE_ASSET__038c23de__"